import React from 'react'
import styled from 'styled-components'
import { RegularCol, RegularRow } from '../../utils/Grid'
import WidgetContainer from '../../containers/WidgetContainer'

const Iframe = styled.iframe`
  width: 100%;
  height: 260px;
`

export default (props) => {
  const {
    widget,
    widget: {
      meta: {
        iframeUrl
      }
    }
  } = props

  return (
    <WidgetContainer widget={widget}>
      <RegularRow>
        <RegularCol>
          <Iframe src={iframeUrl} frameBorder='0'/>
        </RegularCol>
      </RegularRow>
    </WidgetContainer>
  )
}
